import { Loading02Icon } from "hugeicons-react";
import React from "react";

export const PrimaryButton = ({ onClick, buttonText, processingText, isLoading, iconClass, disabled, type }) => {
  return (
    <button onClick={onClick} className="primary-button" disabled={disabled || isLoading} type={type}>
      {
        isLoading
          ? <>
            <Loading02Icon className="loading-icon" />
            {processingText || 'Loading'}
          </>
          : <>
            {iconClass}
            {buttonText || 'Button text'}
          </>
      }
    </button>
  );
}



export const SecondaryButton = React.forwardRef(
  ({ onClick, buttonText, processingText, isLoading, iconClass, className, type }, ref) => {
    return (
      <button onClick={onClick} ref={ref} className={`secondary-button ${className || ''}`} type={type}>
        {isLoading ? (
          <>
            <Loading02Icon className="loading-icon" />
            {processingText || 'Loading'}
          </>
        ) : (
          <>
            {iconClass}
            {buttonText || 'Button text'}
          </>
        )}
      </button>
    );
  }
);
